import { render, staticRenderFns } from "./Observacoes.vue?vue&type=template&id=0ebde04b&scoped=true&"
import script from "./Observacoes.vue?vue&type=script&lang=js&"
export * from "./Observacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebde04b",
  null
  
)

export default component.exports